import { post, get } from "../xhr"

export function createTransaction(data) {
    const formData = new FormData();
    formData.append('paymentType', data.paymentType)
    formData.append('currency', data.currency)
    formData.append('amount', data.amount)
    formData.append('caseId', data.caseId)
    formData.append('reciept', data.reciept)
    return post('/transactions/create/', 'multipart/form-data', formData)
}

export function getTransactions (page = 1) {
    return get(`transactions/?page=${page}`, 'application/json')
}